import type { GroupedSuggestion } from "../types";

import { useAutocompleteContext } from "./AutocompleteContext";
import SuggestionItem from "./SuggestionItem";

interface SuggestionGroupProps {
	group: GroupedSuggestion;
}

/**
 * SuggestionGroup - Renders a group of suggestions with a category header
 */
const SuggestionGroup: React.FC<SuggestionGroupProps> = ({ group }) => {
	const { state, actions } = useAutocompleteContext();

	return (
		<div className="border-b border-elevated-2 last:border-b-0">
			<div className="px-3 py-2 bg-elevated-2 text-xs font-semibold text-gray-300 uppercase tracking-wide border-b border-elevated-2">
				{group.label}
			</div>
			{group.options.map((suggestion) => {
				const suggestionIndex = state.filteredSuggestions.indexOf(suggestion);
				return (
					<SuggestionItem
						key={suggestion.value}
						suggestion={suggestion}
						isHighlighted={suggestionIndex === state.highlightedIndex}
						onSelect={actions.onSuggestionSelect}
						onMouseEnter={() => actions.onHighlightChange(suggestionIndex)}
					/>
				);
			})}
		</div>
	);
};

export default SuggestionGroup;
